import { useState } from 'react';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import ReactDatePicker, { ReactDatePickerProps } from 'react-datepicker';
import * as Styles from './DatePicker.styles';
import 'react-datepicker/dist/react-datepicker.css';
import WarningMessage from '../WarningMessage';

type Props = Omit<
  ReactDatePickerProps<string, boolean>,
  'selected' | 'placeholderText' | 'onChange' | 'value'
> & {
  value?: Date;
  onChange?: (value: Date) => void;
  label?: string;
  placeholder?: string;
  errorMessage?: string;
  isLabelAboveField?: boolean;
};

const DatePicker = ({
  value,
  onChange,
  placeholder = 'Select',
  label,
  name,
  dateFormat = 'MMMM d, yyyy',
  errorMessage,
  inline = false,
  className,
  disabled = false,
  isLabelAboveField = false,
  ...datePickerProps
}: Props): JSX.Element => {
  const handleChange = (date: Date): void => {
    onChange?.(date);
  };

  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleOpen = (): void => {
    setIsOpen(true);
  };

  const handleClose = (): void => {
    setIsOpen(false);
  };

  return (
    <Styles.DatePickerArea
      $labelAboveField={isLabelAboveField}
      $disabled={disabled}
      className={`datepicker ${className || ''} ${isOpen ? 'is-opened' : ''}`}
    >
      {!inline && label && <Styles.Label $right={!isLabelAboveField}>{label}</Styles.Label>}
      {!inline && <CalendarMonthOutlinedIcon />}
      <ReactDatePicker
        name={name}
        placeholderText={placeholder}
        selected={value}
        onChange={handleChange}
        dateFormat={dateFormat}
        inline={inline}
        onCalendarOpen={handleOpen}
        onCalendarClose={handleClose}
        {...datePickerProps}
      />
      {!inline && <WarningMessage errorMessage={errorMessage} />}
    </Styles.DatePickerArea>
  );
};

export default DatePicker;
